<section class="content-2">
  <div class="title-container">
    <h1 class="title">Carga horária de ensino</h1>
    <h2 class="subtitle">Informe a duração dos turnos das aulas.</h2>
  </div>

  <hr class="division-line" />

  <div class="dropdown-panel panel">
    <app-menu-suspenso
      #menuTooltip="matTooltip"
      [matTooltip]="menuTooltipVisible ? 'Visualizar o PQR' : ''"
      matTooltipPosition="above"
      [opcoes]="[
        {
          rotulo: 'PQR desta funcionalidade',
          icone: 'computer',
          acao: 'pqrDestaFuncionalidade'
        },
        {
          rotulo: 'Restaurar valores com base no PQR',
          icone: 'content_copy',
          acao: 'restaurarValoresComBaseNoPqr'
        },
        {
          rotulo: 'PQR completo em nova aba',
          icone: 'desktop_windows',
          acao: 'pqrCompletoEmNovaAba'
        }
      ]"
      (chamadaDeAcao)="chamarAcao($event)"
    >
      Padrão de qualidade de referência (PQR)
    </app-menu-suspenso>

    <mat-icon
      (mouseenter)="openTooltips()"
      (mouseleave)="closeTooltips()"
      class="info-icon"
      #infoTooltip="matTooltip"
      matTooltip="Informações sobre o PQR"
      matTooltipPosition="left"
    >
      info
    </mat-icon>
  </div>

  <div class="panel">
    <div class="table-wrapper">
      <app-tabela
        ngSkipHydration
        class="table-component"
        [cabecalhoCustomizado]="true"
      >
        <ng-container cabecalho>
          <tr>
            <th class="table-header" rowspan="2" style="width: 40%">Etapa</th>
            <th class="table-header" rowspan="2" style="width: 30%">Turno</th>
            <th class="table-header" colspan="2" style="width: 30%">
              Carga horária diária
            </th>
          </tr>
          <tr>
            <th class="table-header" style="width: 15%">
              Média {{anoCenso}} <sup>(1)</sup><sup>(2)</sup>
            </th>
            <th class="table-header" style="width: 15%">PQR</th>
          </tr>
        </ng-container>
        <ng-container corpo>
          <ng-container *ngFor="let dados of dadosTabela">
            <ng-container *ngFor="let turno of dados.turnos; index as i">
              <tr>
                <ng-container *ngIf="i === 0">
                  <td class="table-cell align-left" [attr.rowspan]="dados.turnos.length">
                    {{ dados.etapa.descricao }}
                  </td>
                </ng-container>
                <td class="table-cell">{{ turno.descricao }}</td>
                <td class="table-cell align-right text-blue">
                  {{ dados.medias[i] }}
                </td>
                <td class="table-cell">
                  <input
                    type="number"
                    [(ngModel)]="dados.pqr[i]"
                    (ngModelChange)="atualizarDadosDoServicoDeEstado()"
                    class="display-input text-green"
                    maxlength="2"
                  />
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>
      </app-tabela>
      <app-rodape-fonte-nota
        [foteNota]="[
          {
            titulo: 'Fonte',
            conteudos: [
              {
                numero: 1,
                descricao:
                  'Elaborado a partir dos microdados do Censo Escolar/INEP (arquivo Turmas) ' + anoCenso + '.'
              }
            ]
          },
          {
            titulo: 'Notas',
            conteudos: [
              {
                numero: 2,
                descricao:
                  'São consideradas somente matrículas de escolas públicas. Não são consideradas matrículas de Atividade Complementar e/ou Atendimento Educacional Especializado (AEE). São consideradas turmas diurnas parciais aquelas com jornada diária de ensino inferior a 7 horas e cujas atividades terminam até às 17 horas. São consideradas turmas noturnas aquelas cujas atividades se iniciam a partir das 17 horas. Não são consideradas as matrículas de Educação Infantil (Creche e Pré-escola) em turmas noturnas.'
              }
            ]
          }
        ]"
      >
      </app-rodape-fonte-nota>
    </div>
  </div>
</section>
